import AppLayout from '../../components/base/AppLayout.vue';
import ScansView from './views/ScansView.vue';
import AddScanView from './views/AddScanView.vue';
import ScanResultView from './views/ScanResultView.vue';

const scanRoutes = [
    {
        path: '/scans/',
        component: AppLayout,
        children: [
            {
                path: '',
                name: 'Scans',
                component: ScansView,
                meta: {
                    title: 'Scans',
                    requiresAuth: true,
                }
            },
            {
                path: 'add/',
                name: 'New scan',
                component: AddScanView,
                meta: {
                    title: 'New scan',
                    requiresAuth: true,
                }
            },
            {
                path: ':scan_id/',
                name: 'Scan result',
                component: ScanResultView,
                meta: {
                    title: 'Scan result',
                    requiresAuth: true,
                }
            }
        ]
    }
]

export default scanRoutes;